import { io, Socket } from "socket.io-client";
import { GarudaRequest } from "./request/models/events";
import { GarudaResponse } from "./response/models/events";
import { HandlerPicker } from "./response/handler/CloudCoreResponseHandlers";

declare const genv: any;
export interface CloudCoreClientProps {
  handleOnConnect: any,
  handleOnDisconnect: any
}

export class CloudCoreClient {
  private socket: Socket;

  constructor() {
    this.socket = io(genv.CLOUD_CORE_URL || "http://garuda-local.sbx.tech");
  }

  connect(): void {
    this.socket.connect();
  }

  disconnect(): void {
    this.socket.disconnect();
  }

  sendEvent(event: GarudaRequest) {
    this.socket.emit("sendRequestToGateway", event);
  }

  attachHandlers(handlerPicker: HandlerPicker): void {
    this.socket.on("MessageFromGateway", (response: GarudaResponse) => {
      handlerPicker(response.header.id)(response);
    });
  }

  attachConnectionHandler(params: CloudCoreClientProps):void {
    this.socket.on("connect", () => params.handleOnConnect());
    this.socket.on("disconnect", () => params.handleOnDisconnect());
  }
}
